import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './getnetPayment.css'
import Text from '../../components/text/Text'
import routes from '../../router/routes'
//import CheckIcon from '../../assets/images/bci/check.png'
import ExclamationIcon from '../../assets/images/bci/exclamation.png'
import TimeIcon from '../../assets/images/bci/time.png'
import XIcon from '../../assets/images/bci/x.png'

import { clevertapEvents, labels } from '../../labels'
import { getProcessedGetnetPayment } from '../../services/payment'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import styles from './successfulPayment.module.css'
import success from '../../assets/icons/icons-success.svg'
import Moment from 'moment'
import SvgIcon from '../../components/svgIcon/SvgIcon'
type ORDER_STATUS = 'REJECTED' | 'AUTHORIZED' | 'PENDING' | 'ERROR' | 'TIMEOUT'

export default function GetnetPayment() {
    const hasGetnetOrderPending = localStorage.getItem('getnet-payment')
    const [orderStatus, setOrderStatus] = useState<ORDER_STATUS>('PENDING')
    const navigation = useNavigate()

    const [file, setFile] = useState<string>()

    const navigateBack = () => {
        navigation(`/${routes.payment}`)
    }
    const navigateToHome = () => {
        navigation(`${routes.home}`)
    }
    const navigateToPayment = () => {
        navigation(`/${routes.payment}`)
    }
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [amount, setAmount] = useState<number | null>(null)
    const [authorizationCode, setAuthorizationCode] = useState<string | null>(
        null
    )
    const paymentEventParms = {
        pageName: 'GetnetPayment',
        pageURL: routes.getnet,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'hh:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const checkStatus = async () => {
        try {
            const { status, authorizationCode, amount, fileInvoice } =
                await getProcessedGetnetPayment(hasGetnetOrderPending)

            if (fileInvoice) {
                setFile(fileInvoice)
            }

            if (status === 'PENDING') {
                setTimeout(() => {
                    checkStatus()
                }, 1000)
                return
            }
            if (status === 'AUTHORIZED') {
                setAmount(amount)
                setAuthorizationCode(authorizationCode)

                setOrderStatus('AUTHORIZED')
                return
            }
            if (status === 'REJECTED') {
                setOrderStatus('REJECTED')
                return
            }
            if (status === 'TIMEOUT') {
                setOrderStatus('TIMEOUT')
                return
            }
            setOrderStatus('ERROR')
        } catch (e) {
            setOrderStatus('ERROR')
        }
    }

    const openPdf = () => {
        if (file) {
            const byteCharacters = atob(file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], { type: 'application/pdf' })
            const url = URL.createObjectURL(blob)
            window.open(url)
        }
    }

    useEffect(() => {
        checkStatus()
    }, [])

    useEffect(() => {
        if (orderStatus === 'AUTHORIZED') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_exito,
                paymentEventParms
            )
        }
    }, [orderStatus])
    useEffect(() => {
        if (orderStatus === 'REJECTED') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_rechazada,
                paymentEventParms
            )
        }
    }, [orderStatus])
    useEffect(() => {
        if (orderStatus === 'PENDING') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_pending,
                paymentEventParms
            )
        }
    }, [orderStatus])

    const PendingComponent = () => {
        return (
            <div className="getnet-waitng-payment-card">
                <img src={TimeIcon} alt="time" style={{ marginBottom: 15 }} />
                <Text
                    label={labels.bciPayment.pending.line1}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <Text
                    label={labels.bciPayment.pending.line2}
                    variant="md-medium titleStyle"
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <Text
                    label={'...'}
                    variant="md-medium  bci-waitng-payment-dots"
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
            </div>
        )
    }

    const FailedComponent = () => {
        return (
            <div className="getnet-waitng-payment-card getnet-waiting-payment-short-container">
                <img
                    src={ExclamationIcon}
                    alt="exclamation"
                    style={{ marginBottom: 15, gap: '16px' }}
                />
                <Text
                    label={labels.bciPayment.failed}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <button onClick={navigateBack} className="getnet-timeout-btn">
                    <Text
                        label="Volver a intentar cobro "
                        variant="md-medium"
                        fontSize={24}
                        fontWeight={500}
                        color={'#565656'}
                    />
                </button>
            </div>
        )
    }

    const SuccessComponent = () => {
        return (
            <div className={styles.parent}>
                <div className={styles.containerSuccess}>
                    <div className={styles.iconContainer}>
                        <img src={success} className={styles.iconStyle} />
                    </div>
                    <div className={styles.textContainer}>
                        <Text
                            label={labels.paymentVoucher}
                            variant={`H6 ${styles.commontTextLineHeight} `}
                            marginTop={20}
                            marginBottom={20}
                        />
                        <Text
                            label={user?.cLocal[0]?.sNombreLocal}
                            variant={`H4 ${styles.commontTextLineHeight}`}
                            marginTop={20}
                            marginBottom={20}
                        />
                        <Text label={user.sDireccion} variant="md-medium" />
                        <Text
                            label={
                                amount !== null
                                    ? new Intl.NumberFormat('es-CL', {
                                          style: 'currency',
                                          currency: 'CLP',
                                          minimumFractionDigits: 0,
                                      }).format(amount)
                                    : '$ 0'
                            }
                            variant={`H2 ${styles.commontTextLineHeight} `}
                            marginTop={40}
                            marginBottom={40}
                        />
                        <div className={styles.rowContainer}>
                            <Text
                                label={labels.paymentAuthorizationCode}
                                variant={`Body2-14 bold  ${styles.commontTextLineHeight} `}
                                marginTop={20}
                                marginBottom={20}
                            />
                            <Text
                                label={authorizationCode ?? ''}
                                variant={`Body2-14 bold  ${styles.commontTextLineHeight} ${styles.blue}`}
                                marginTop={20}
                                marginBottom={20}
                            />
                        </div>
                        <div className={styles.rowContainer}>
                            <Text
                                label={labels.paymentDate}
                                variant={`Body2-14 bold  ${styles.commontTextLineHeight} `}
                                marginTop={20}
                                marginBottom={20}
                            />
                            <Text
                                label={Moment(
                                    paymentEventParms.date +
                                        ' ' +
                                        paymentEventParms.hour
                                ).format('DD/MM/YYYY - hh:mm:ss')}
                                variant={`Body2-14 bold  ${styles.commontTextLineHeight}  ${styles.blue}`}
                                marginTop={20}
                                marginBottom={40}
                            />
                        </div>
                        <div style={{ marginTop: 15, marginBottom: 5 }}>
                            {file ? (
                                <button
                                    onClick={openPdf}
                                    style={{
                                        gap: 7,
                                        display: 'flex',
                                        cursor: 'pointer',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textDecoration: 'underline',
                                        backgroundColor: 'transparent',
                                    }}
                                >
                                    <Text
                                        label="Descargar la boleta en PDF"
                                        variant="bold"
                                    />
                                    <SvgIcon iconName="PdfIcon" />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        gap: 7,
                                        maxWidth: 350,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <div style={{ width: 30 }}>
                                        <SvgIcon iconName="warning" />
                                    </div>
                                    <Text
                                        variant="Caption3-13"
                                        label="Se presentó un problema para generar la boleta electrónica. Por favor contacta a nuestro equipo de soporte."
                                    />
                                </div>
                            )}
                        </div>
                        <Text label="amiPASS ®" variant={`Small-2`} />
                    </div>
                    <div className={styles.buttonsContainer}>
                        <div
                            className={styles.whiteButtonContainer}
                            onClick={navigateToHome}
                        >
                            <Text
                                label={labels.paymentBackHome}
                                variant={'ButtonLg-16'}
                            />
                        </div>
                        <div
                            className={styles.blueButtonContainer}
                            onClick={navigateToPayment}
                        >
                            <Text
                                label={labels.backPayment}
                                variant={'ButtonLg-16'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const TimeoutComponent = () => {
        return (
            <div className="getnet-error-payment-card">
                <img src={XIcon} alt="time" style={{ marginBottom: 15 }} />
                <Text
                    label={labels.bciPayment.timeout}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <button onClick={navigateBack} className="getnet-timeout-btn">
                    <Text
                        label="Volver a intentar cobro "
                        variant="md-medium"
                        fontSize={24}
                        fontWeight={500}
                        color={'#565656'}
                    />
                </button>
            </div>
        )
    }

    const ComponentToRender = () => {
        if (orderStatus === 'PENDING') return <PendingComponent />
        if (orderStatus === 'AUTHORIZED') return <SuccessComponent />
        if (orderStatus === 'TIMEOUT') return <TimeoutComponent />
        if (orderStatus === 'REJECTED') return <FailedComponent />
        return <FailedComponent />
    }

    return (
        <div className="getnet-waitng-payment-container">
            <ComponentToRender />
        </div>
    )
}
